// extracted by extract-css-chunks-webpack-plugin
module.exports = {"IconSvg__neutralizeFill":"IconSvg__neutralizeFill_3Fmgc_v16-5-1"};